/** Single source for JWT storage and Authorization header formatting. */
export const AUTH_TOKEN_STORAGE_KEY = "token";

export const getBearerToken = () => sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY) || null;

export const setBearerToken = (token) => {
  if (token) {
    sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
  } else {
    sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
  }
};

export const getAuthorizationHeaderValue = () => {
  const token = getBearerToken();
  return token ? `Bearer ${token}` : null;
};

/** Plain object for axios/fetch headers, e.g. { Authorization: "Bearer ..." }. */
export const getAuthorizationHeaders = () => {
  const authorization = getAuthorizationHeaderValue();
  return authorization ? { Authorization: authorization } : {};
};
